/* eslint-disable no-unused-vars */
import Cookies from 'js-cookie';
var COOKIE_DEFAULT_PATH = '/';
var COOKIE_DEFAULT_DOMAIN = '.olx.com.br';
var COOKIE_DEFAULT_EXPIRATION = 365;
export function deleteCookie(cookieName) {
  Cookies.remove(cookieName, {
    path: COOKIE_DEFAULT_PATH,
    domain: COOKIE_DEFAULT_DOMAIN
  });
}
export function clearCookies() {
  var allCookies = Cookies.get();
  Object.entries(allCookies).forEach(function (_ref) {
    var cookieName = _ref[0],
      _ = _ref[1];
    deleteCookie(cookieName);
  });
}
export function deleteCookies(cookieNames) {
  cookieNames.forEach(deleteCookie);
}
export function setCookie(cookieName, cookieValue, exp) {
  Cookies.set(cookieName, cookieValue, {
    path: COOKIE_DEFAULT_PATH,
    domain: COOKIE_DEFAULT_DOMAIN,
    expires: exp || COOKIE_DEFAULT_EXPIRATION
  });
}
export function getCookie(cookieName) {
  if (cookieName) return Cookies.get(cookieName);
  return Cookies.get();
}
export function recoverCookies(cookies) {
  Object.entries(cookies).forEach(function (_ref2) {
    var cookieName = _ref2[0],
      cookieValue = _ref2[1];
    setCookie(cookieName, cookieValue);
  });
}